import * as React from "react";
import { merge, $ } from "glamor";

interface IProps {
    color: string;
    list: boolean;
}

const BulkDragPlaceholder: React.FC<IProps> = (props) => {
    const { color, list } = props;

    const styles = React.useMemo(() => {
        return merge(
            {
                position: "absolute",
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            },
            $(" .line", {
                background: color,
                height: list ? "4px" : "100%",
                width: list ? "100%" : "4px",
            })
        );
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div {...styles}>
            <div className="line"></div>
        </div>
    );
};

export default BulkDragPlaceholder;
